"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderingPropTypes = exports.heatmapDataPropTypes = exports.heatmapConfigPropTypes = exports.groupedColumnPropTypes = exports.filterPropTypes = exports.dataSeriesPropTypes = exports.columnGroupsPropTypes = exports.columnCategoryPropTypes = exports.colourAxisPropTypes = exports.chartDataPropTypes = exports.boxplotData = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _experimentTypeUtils = require("../load/experimentTypeUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// const heatmapDataPropTypes = (props, propName) => {
//     const heatmapData = props[propName]
//     // const possiblyError = ValidateDataSeries(heatmapData.dataSeries)
//     // if (possiblyError !== undefined) {
//     //     return possiblyError
//     // }
//
//     const width = heatmapData.xAxisCategories.length
//     const height = heatmapData.yAxisCategories.length
//
//     for (let i = 0 i < heatmapData.dataSeries.length i++) {
//         for (let j = 0 j < heatmapData.dataSeries[i].data.length j++) {
//             const point = heatmapData.dataSeries[i].data[j]
//             const x = point.x
//             const y = point.y
//             if (x < 0 || y < 0 || x >= width || y >= height) {
//                 return new Error(`Point with coordinates outside range: ${x}, ${y}`)
//             }
//         }
//     }
// }
var differentialTooltipPropTypes = _propTypes["default"].shape({
  contrastDescription: _propTypes["default"].string.isRequired,
  experimentDescription: _propTypes["default"].string.isRequired,
  properties: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    contrastPropertyType: _propTypes["default"].oneOf(["FACTOR", "SAMPLE"]),
    propertyName: _propTypes["default"].string.isRequired,
    referenceValue: _propTypes["default"].string.isRequired,
    testValue: _propTypes["default"].string.isRequired
  })).isRequired,
  referenceReplicates: _propTypes["default"].number.isRequired,
  resources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    icon: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired
  })).isRequired,
  testReplicates: _propTypes["default"].number.isRequired
});

var baselineTooltipPropTypes = _propTypes["default"].shape({
  properties: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    contrastPropertyType: _propTypes["default"].oneOf(["FACTOR", "SAMPLE"]),
    propertyName: _propTypes["default"].string.isRequired,
    testValue: _propTypes["default"].string.isRequired
  })).isRequired,
  replicates: _propTypes["default"].number.isRequired
});

var baselineExperimentsTooltipPropTypes = _propTypes["default"].shape({});

var orderingPropTypes = function orderingPropTypes(props, propName, componentName) {
  var ordering = props[propName];

  var isPermutation = function isPermutation(arr) {
    return [].concat(arr).sort(function (a, b) {
      return a - b;
    }).map(function (el, ix) {
      return el === ix;
    }).reduce(function (l, r) {
      return l && r;
    });
  };

  if (!ordering.name) {
    return new Error("Ordering with no name in '".concat(componentName, "'"));
  }

  if (!isPermutation(ordering.columns)) {
    return new Error("Column ordering invalid: '".concat(ordering.name, "' in '").concat(componentName, "'"));
  }

  if (!isPermutation(ordering.rows)) {
    return new Error("Row ordering invalid: '".concat(ordering.name, "' in '").concat(componentName, "'"));
  }
};

exports.orderingPropTypes = orderingPropTypes;

var dataSeriesPropTypes = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    info: _propTypes["default"].shape({
      unit: _propTypes["default"].string.isRequired,
      foldChange: _propTypes["default"].number,
      // These three only in diff experiments
      pValue: _propTypes["default"].number,
      tStat: _propTypes["default"].number
    }).isRequired,
    value: _propTypes["default"].number.isRequired,
    x: _propTypes["default"].number.isRequired,
    y: _propTypes["default"].number.isRequired
  })).isRequired,
  info: _propTypes["default"].shape({
    colour: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired
  }).isRequired
}));

exports.dataSeriesPropTypes = dataSeriesPropTypes;

var groupingPropType = _propTypes["default"].shape({
  memberName: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired
});

var groupedColumnPropTypes = _propTypes["default"].shape({
  value: _propTypes["default"].string.isRequired,
  categories: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired,
  groupings: _propTypes["default"].arrayOf(groupingPropType).isRequired
});

exports.groupedColumnPropTypes = groupedColumnPropTypes;

var columnCategoryPropTypes = _propTypes["default"].shape({
  name: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool.isRequired
});

exports.columnCategoryPropTypes = columnCategoryPropTypes;

var columnGroupsPropTypes = _propTypes["default"].shape({
  groupingNames: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired,
  categories: _propTypes["default"].arrayOf(columnCategoryPropTypes).isRequired,
  data: _propTypes["default"].arrayOf(groupedColumnPropTypes.isRequired).isRequired
});

exports.columnGroupsPropTypes = columnGroupsPropTypes;

var heatmapDataPropTypes = _propTypes["default"].shape({
  dataSeries: dataSeriesPropTypes.isRequired,
  xAxisCategories: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    info: _propTypes["default"].shape({
      tooltip: _propTypes["default"].oneOfType([differentialTooltipPropTypes, baselineTooltipPropTypes, baselineExperimentsTooltipPropTypes]).isRequired,
      trackId: _propTypes["default"].string.isRequired
    }).isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,
  yAxisCategories: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    info: _propTypes["default"].shape({
      designElement: _propTypes["default"].string.isRequired,
      trackId: _propTypes["default"].string.isRequired
    }).isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired
});

exports.heatmapDataPropTypes = heatmapDataPropTypes;
var boxplotData = {
  boxplotSeries: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    x: _propTypes["default"].number,
    low: _propTypes["default"].number,
    q1: _propTypes["default"].number,
    median: _propTypes["default"].number,
    q3: _propTypes["default"].number,
    high: _propTypes["default"].number
  })).isRequired,
  loosePointsSeries: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  })).isRequired,
  xAxisCategories: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  unit: _propTypes["default"].string.isRequired
};
exports.boxplotData = boxplotData;

var boxplotDataPropTypes = _propTypes["default"].shape(boxplotData);

var heatmapConfigPropTypes = _propTypes["default"].shape({
  inProxy: _propTypes["default"].string.isRequired,
  outProxy: _propTypes["default"].string.isRequired,
  atlasUrl: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  genomeBrowsers: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  introductoryMessage: _propTypes["default"].string.isRequired,
  shortDescription: _propTypes["default"].string.isRequired,
  xAxisLegendName: _propTypes["default"].string.isRequired,
  yAxisLegendName: _propTypes["default"].string.isRequired,
  experiment: _experimentTypeUtils.experimentPropTypes,
  showControlMenu: _propTypes["default"].bool.isRequired,
  disclaimer: _propTypes["default"].string.isRequired,
  coexpressionsAvailable: _propTypes["default"].bool.isRequired,
  isMultiExperiment: _propTypes["default"].bool.isRequired,
  isBaseline: _propTypes["default"].bool.isRequired,
  isDifferential: _propTypes["default"].bool.isRequired
});

exports.heatmapConfigPropTypes = heatmapConfigPropTypes;

var filterPropTypes = _propTypes["default"].shape({
  name: _propTypes["default"].string.isRequired,
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool.isRequired
  })).isRequired,
  valueGroupings: _propTypes["default"].array // Indirectly validated as [string, array of strings] in FilterOption

});

exports.filterPropTypes = filterPropTypes;

var colourAxisPropTypes = _propTypes["default"].shape({
  unit: _propTypes["default"].string.isRequired,
  dataClasses: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    color: _propTypes["default"].string.isRequired,
    from: _propTypes["default"].number.isRequired,
    to: _propTypes["default"].number.isRequired
  })).isRequired
});

exports.colourAxisPropTypes = colourAxisPropTypes;

var chartDataPropTypes = _propTypes["default"].shape({
  heatmapConfig: heatmapConfigPropTypes.isRequired,
  colourAxis: colourAxisPropTypes,
  orderings: _propTypes["default"].arrayOf(orderingPropTypes),
  heatmapData: heatmapDataPropTypes.isRequired,
  boxplotData: boxplotDataPropTypes,
  columnGroups: _propTypes["default"].object.isRequired
});

exports.chartDataPropTypes = chartDataPropTypes;